import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

import { PushpinOutlined } from '@ant-design/icons';
import { getColor, getSize, MathEnabledTextComponent, SecondaryButton, styleVariables } from '@lib/common';
import { Typography } from 'antd';
import styled from '@xstyled/styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Card = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  flex-shrink: 0;\n  width: 100%;\n  padding: ", ";\n  padding-top: ", ";\n  margin-bottom: ", ";\n  border-radius: 12px;\n  border: 1px solid ", ";\n  background: #eff6ff;\n  box-shadow: 0px 3px 6px ", ";\n  overflow: hidden;\n"])), getSize('padding24'), getSize('padding32'), getSize('padding16'), styleVariables.colors.blue3, styleVariables.colors.transparentGray6);
var SectionBadge = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: ", " ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  background: #dbeafe;\n  border-radius: ", ";\n  font-weight: 700;\n  text-transform: uppercase;\n"])), getSize('padding4'), getSize('padding8'), getSize('typo14'), getSize('typo20'), getColor('fillIntActive'), getSize('radiusS'));
var PinnedRibbon = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: ", ";\n  color: ", ";\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  border-radius: 0 0 0 8px;\n  position: absolute;\n  top: 0;\n  right: 0;\n"])), styleVariables.colors.blue3, styleVariables.colors.gray1);
var HeaderRow = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: ", ";\n  margin-bottom: ", ";\n"])), getSize('padding8'), getSize('padding12'));
var CondensedHint = styled.p(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin: 0 0 ", ";\n  font-style: italic;\n  font-size: 14px;\n  color: ", ";\n"])), getSize('padding16'), styleVariables.colors.gray10);
var TrackingBox = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  border: 1px dashed ", ";\n  background: rgba(26, 90, 255, 0.06);\n  border-radius: 8px;\n  padding: ", ";\n  text-align: center;\n  margin-bottom: ", ";\n"])), styleVariables.colors.blue3, getSize('padding16'), getSize('padding16'));
var TrackingText = styled.p(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  margin: 0 0 ", ";\n  font-size: 14px;\n  color: ", ";\n  font-weight: 500;\n"])), getSize('padding12'), styleVariables.colors.blue3);
export var SectionPinnedShortcut = function SectionPinnedShortcut(_ref) {
  var section = _ref.section,
      sectionDisplayIndex = _ref.sectionDisplayIndex,
      labels = _ref.labels,
      sectionWord = _ref.sectionWord,
      onUnpinSection = _ref.onUnpinSection;
  return /*#__PURE__*/_jsxs(Card, {
    id: "submission-section-".concat(section.id),
    "data-section-row": "shortcut",
    "data-pinned-section-shortcut": "true",
    "aria-label": "".concat(labels.pinnedBadge, ": ").concat(sectionWord, " ").concat(sectionDisplayIndex + 1),
    children: [/*#__PURE__*/_jsxs(PinnedRibbon, {
      children: [/*#__PURE__*/_jsx(PushpinOutlined, {
        "aria-hidden": true
      }), /*#__PURE__*/_jsx("span", {
        children: labels.pinnedBadge
      })]
    }), /*#__PURE__*/_jsxs(HeaderRow, {
      children: [/*#__PURE__*/_jsxs(SectionBadge, {
        children: [sectionWord, " ", sectionDisplayIndex + 1]
      }), /*#__PURE__*/_jsx(Typography.Title, {
        level: 4,
        style: {
          margin: 0,
          fontSize: 18,
          fontWeight: 700,
          color: styleVariables.colors.gray13
        },
        children: /*#__PURE__*/_jsx(MathEnabledTextComponent, {
          value: section.title
        })
      })]
    }), /*#__PURE__*/_jsx(CondensedHint, {
      children: labels.condensedHint
    }), /*#__PURE__*/_jsxs(TrackingBox, {
      children: [/*#__PURE__*/_jsx(TrackingText, {
        children: labels.trackingMessage
      }), /*#__PURE__*/_jsx(SecondaryButton, {
        onClick: onUnpinSection,
        children: labels.unpinSection
      })]
    })]
  });
};